
import filters from "@/filters";
import { Component, Prop, Vue } from "vue-property-decorator";
import { formDataAppend } from "@/functions/global.function";
import { Action } from "vuex-class";

@Component({
  components: {},
  filters,
})
export default class ModalBroadcastCandidate extends Vue {
  @Action("adminJobFairOrganizerBroadcastCandidate", { namespace: "admin" })
  private adminJobFairOrganizerBroadcastCandidate: any;

  @Prop({ default: null })
  private data!: any;
  @Prop({ default: null })
  private jobFair!: any;

  private submit() {
    const formData = new FormData();
    formData.append("id", this.jobFair?.id);
    formData.append("subject", this.data.subject);
    formData.append("body", this.data.body);
    if (
      (this.data.attendance && this.data.registered) ||
      (!this.data.attendance && !this.data.registered)
    ) {
      formData.append("status", "all");
    } else if (this.data.attendance) {
      formData.append("status", "attendance");
    } else if (this.data.registered) {
      formData.append("status", "registered");
    }
    formDataAppend(formData, this.data.attachments, "attachments");
    this.adminJobFairOrganizerBroadcastCandidate({
      params: formData,
      success: () => {
        this.$bvModal.hide("modal-broadcast-candidate");
      },
    });
  }
}
